import Vue from 'vue'
import Router from 'vue-router'
import RouterView from '@/frame/router-view'
import index from '@/components/index'
import goodslist from '@/components/goods/goods-list'
import recomendlist from '@/components/goods/recomend-list'

import goodsdetail from '@/components/goods/detail'
import cart from '@/components/goods/cart'
import orderCreate from '@/components/order/create'
import User from '@/components/user/index'
import UserHome from '@/components/user/home'
import addressManage from '@/components/user/addressManage';
import userManage from '@/components/user/manage';
import childManage from '@/components/user/childManage';
import userOrder from '@/components/order/list'
import orderAudit from '@/components/order/listAudit'
import orderDetail from '@/components/order/detail'
import detailAudit from '@/components/order/detailAudit'
import regist from '@/components/user/regist'
import help from '@/components/help'
import forget from '@/components/user/forget'
import myAttention from '@/components/user/myAttention'
import myBrowse from '@/components/user/myBrowse'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        {
          path: '/goodslist',
          name: 'goodslist',
          component: goodslist,
          children: [

          ]
        },
        {
          path: '/recomendlist',
          name: 'recomendlist',
          component: recomendlist,
          children: [

          ]
        },
        {
          path: '/goodsdetail',
          name: 'goodsdetail',
          component: goodsdetail,
          children: [

          ]
        },
        {
          path: '/cart',
          name: 'cart',
          component: cart,
          children: [

          ]
        },
        {
          path: '/order',
          name: 'order',
          component: RouterView,
          children: [
            {
              path: '/order/create',
              name: 'orderCreate',
              component: orderCreate,
            },
            {
              path: '/order/orderDetail',
              name: 'orderDetail',
              component: orderDetail,
            },
            {
              path: '/order/detailAudit',
              name: 'detailAudit',
              component: detailAudit,
            },

          ]
        },
        {
          path: '/user',
          name: 'user',
          component: User,
          children: [
            {
              path: '/user/home',
              name: 'homeCenter',
              component: UserHome,
              children: [

              ]
            },
            {
              path: '/user/order',
              name: 'userOrder',
              component: userOrder,
            },
            {
              path: '/user/orderAudit',
              name: 'orderAudit',
              component: orderAudit,
            },
            {
              path: '/user/addressManage',
              name: 'addressManage',
              component: addressManage,
            },
            {
              path: '/user/manage',
              name: 'userManage',
              component: userManage,
            },
            {
              path: '/user/childManage',
              name: 'childManage',
              component: childManage,
            },
            {
              path: '/user/myAttention',
              name: 'myAttention',
              component: myAttention,
            },
            {
              path: '/user/myBrowse',
              name: 'myBrowse',
              component: myBrowse,
            },
          ]
        },
        {
          path: '/regist',
          name: 'regist',
          component: regist,
        },
        {
          path: '/help',
          name: 'help',
          component: help,
        },
        {
          path: '/forget',
          name: 'forget',
          component: forget,
        },

        
      ]
    },
    {
      path: '/404',
      name: 'nopage',
    }
  ]
})
